import gql from 'graphql-tag'

export const typeDefs = gql`
  enum QuestionFlowType {
    Later
    Core
  }

  type spendPrefundAmount {
    value: Int!
  }

  type spendPrefundAmountInput {
    value: Int!
    __typename: String!
  }

  type StoredQuestionInput {
    questionId: String!
    answerId: String
    questionPath: String
    page: Int!
    flowType: QuestionFlowType!
  }

  type StoredQuestion {
    id: ID!
    questionId: String!
    answerId: String
    questionPath: String
    page: Int!
    flowType: QuestionFlowType
  }

  type LaterSuitabilityStateInput {
    storedQuestions: [StoredQuestion!]
    recommendation: String
    showCoreSuitabilityQuestions: Boolean
    coreSuitabilityQuestions: [suitability_SuitabilityQuestion!]
    page: Int
    showNextButton: Boolean
  }

  type LaterSuitabilityState {
    id: ID!
    storedQuestions: [StoredQuestion]
    recommendation: String
    showCoreSuitabilityQuestions: Boolean
    coreSuitabilityQuestions: [suitability_SuitabilityQuestion!]
    page: Int
    showNextButton: Boolean
  }

  type SignaturePoint {
    id: ID!
    points: [String]
    socketId: String
    width: Int
  }

  extend type Mutation {
    setLaterSuitabilityState(input: LaterSuitabilityStateInput!): [LaterSuitabilityState!]
  }

  extend type Mutation {
    setSpendPrefundAmount(input: spendPrefundAmountInput!): spendPrefundAmount!
  }

  extend type Query {
    spendPrefundAmount: spendPrefundAmount
  }

  extend type Query {
    suitabilityState: LaterSuitabilityState
  }

  extend type Query {
    signaturePoints: SignaturePoint
  }
`
